import { createClient } from "@connectrpc/connect";
import {
  BaseGrpcCatalogService,
  GrpcCatalogoFetchResult,
} from "../../../../base/services/BaseGrpcCatalogService";
import { grpcTransportProvider } from "../../../../comun/services/grpc/GrpcTransport";
import { mapConnectError } from "../../../../comun/services/grpc/mapConnectError";
import {
  CatalogosSateliteService,
  IndiceItem,
} from "../../../../generated/grpc/catalogos_satelite_pb";

/** Variante gRPC-Web (con delta) de `IndiceGetCatalogService` (ver ese archivo). */
export class IndiceGrpcCatalogService extends BaseGrpcCatalogService<IndiceItem> {
  protected readonly storeName = "indicesSatelite" as const;
  protected readonly sortFieldName = "nombre";

  protected async fetchAsync(ultimaSincronizacion: bigint): Promise<GrpcCatalogoFetchResult<IndiceItem>> {
    const client = createClient(CatalogosSateliteService, grpcTransportProvider.get());

    try {
      const response = await client.listIndices({ ultimaSincronizacion });
      return { items: response.items, timestampSincronizacion: response.timestampSincronizacion };
    } catch (error) {
      throw mapConnectError(error);
    }
  }
}

/** Singleton del servicio gRPC del catálogo de índices satelitales. */
export const indiceGrpcCatalogService = new IndiceGrpcCatalogService();
